import type { ReactNode } from 'react';

type BadgeMode = 'ok' | 'updating' | 'stale' | 'error';

interface Props {
  mode: BadgeMode;
  children: ReactNode;
}

export default function LiveBadge({ mode, children }: Props) {
  const tone =
    mode === 'ok'
      ? 'ui-live-badge ui-live-badge--ok'
      : mode === 'updating'
        ? 'ui-live-badge ui-live-badge--updating'
        : mode === 'error'
          ? 'ui-live-badge ui-live-badge--bad'
          : 'ui-live-badge ui-live-badge--stale';

  return (
    <span className={`inline-flex items-center border px-1.5 py-0.5 rounded text-[9px] ${tone}`}>
      {children}
    </span>
  );
}
